module.exports = __webpack_public_path__ + "assets/logo.68245e6d4992c6711d67a2f77d500470.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo.png
// module id = 871
// module chunks = 4